var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',[_c('v-col',{attrs:{"sm":"12"}},[_c('h1',{staticClass:"text-h4 primary--text"},[_vm._v("Wyoming Property Tax Refund Program")]),_c('h2',{staticClass:"text-subtitle-1 primary--text"},[_vm._v("Filing Instructions")])]),_c('v-col',{attrs:{"sm":"12"}},[_c('Instructions')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }